import React from 'react'

export default({ title }) => {
  let superscript = "";
  if (title.includes("SM"))
    superscript = "SM";

  return <p>{title.replace("SM","")}<sup>{superscript}</sup></p>
}